import { Outlet } from 'react-router-dom'
import TopBar from '@/src/components/layout/top-bar/TopBar'
import { useState } from 'react'

const RootLayout = () => {
  const [title, setTitle] = useState('')
  const [subTitle, setSubTitle] = useState('')
  return (
    <div className="h-dvh flex flex-col">
      <TopBar variant="light" title={title} subtitle={subTitle} hideNavigationButtons={true} />
      <main className="flex-1 overflow-y-auto">
        <Outlet context={{ setTitle, setSubTitle }} />
      </main>
    </div>
  )
}

export default RootLayout
